<template lang="pug">
.facility-setting-tab(v-if="_value")
  .mb-3
  .box-body.register-body.tab-content(v-if="waiterRecruitment != null")
    .d-flex.justify-content-start.align-items-center.flex-wrap-reverse(style="width: 100%;")
      //- basicInformation
      .d-flex.justify-content-start.flex-column
        .sub-title 基本情報
        .group
          .group-item.p-2
            FormInput(v-model="waiterRecruitment.basicInformation.facilityName" name="facility-name" key-name="施設名" type="text" placeholder="施設名"
              :maxlength="100" :validation-rules="{ required: true, max: 100 }" :styles="{ width: '720px', 'max-width': '720px' }" required)

            FormFile(v-model="headerImageUrl1" key-name="ヘッダー画像１" name="header-image-1" :file-name.sync="headerImageName1"
              mimetype="image/*" width="720px" clip)
              template(v-slot:question)
                HelpIcon(:popoverId="'facility-setting-tab-vacancy-header-image-help-1'"
                  :title="'選択可能なファイルについて'" :text="'jpegもしくはpngを選択可能です。'")
            .buttons.d-flex.flex-row.justify-content-end
              button.btn.preview-btn(:disabled="disablePreviewButton(headerImage1)" :class="{ 'disable': disablePreviewButton(headerImage1) }"
                @click="onPreview(headerImage1)") プレビュー
            .mb-2
            FormFile(v-model="headerImageUrl2" key-name="ヘッダー画像２" name="header-image-2" :file-name.sync="headerImageName2"
              mimetype="image/*" width="720px" clip)
              template(v-slot:question)
                HelpIcon(:popoverId="'facility-setting-tab-vacancy-header-image-help-2'"
                  :title="'選択可能なファイルについて'" :text="'jpegもしくはpngを選択可能です。'")
            .buttons.d-flex.flex-row.justify-content-end
              button.btn.preview-btn(:disabled="disablePreviewButton(headerImage2)" :class="{ 'disable': disablePreviewButton(headerImage2) }"
                @click="onPreview(headerImage2)") プレビュー
            .mb-2
            FormFile(v-model="headerImageUrl3" key-name="ヘッダー画像３" name="header-image-3" :file-name.sync="headerImageName3"
              mimetype="image/*" width="720px" clip)
              template(v-slot:question)
                HelpIcon(:popoverId="'facility-setting-tab-vacancy-header-image-help-3'"
                  :title="'選択可能なファイルについて'" :text="'jpegもしくはpngを選択可能です。'")
            .buttons.d-flex.flex-row.justify-content-end
              button.btn.preview-btn(:disabled="disablePreviewButton(headerImage3)" :class="{ 'disable': disablePreviewButton(headerImage3) }"
                @click="onPreview(headerImage3)") プレビュー
            .mb-2

            FormInputSelect(v-model="waiterRecruitment.basicInformation.facilityType" name="facility-type" key-name="施設種別"
              :validation-rules="{ required: true }" :options="facilityTypeOptions" :styles="{ 'max-width': '540px' }" required)
            FormInput(v-model="waiterRecruitment.basicInformation.address" name="facility-address" key-name="住所" type="text" placeholder="住所"
              :maxlength="100" :validation-rules="{ required: true, max: 100 }" :styles="{ width: '720px', 'max-width': '720px' }" required)
            FormInput(v-model="waiterRecruitment.basicInformation.facilityUrl" name="facility-url" key-name="ホームページURL" type="text"
              placeholder="ホームページURL" :maxlength="10000"
              :validation-rules="{ url: { require_protocol: ['http', 'https'] }, max: 10000 }" :styles="{ width: '720px', 'max-width': '720px' }")
            FormInput(v-model="waiterRecruitment.basicInformation.corporationName" name="facility-corporation-name" key-name="運営法人" type="text"
              placeholder="運営法人" :maxlength="100" :validation-rules="{ required: true, max: 100 }" :styles="{ width: '720px', 'max-width': '720px' }" required)
            FormInput(v-model="waiterRecruitment.basicInformation.tel" name="tel" key-name="電話番号" type="text" placeholder="電話番号"
              :maxlength="100" :validation-rules="{ tel: true, max: 14 }" :styles="{ width: '720px', 'max-width': '720px' }")
            FormInput(v-model="waiterRecruitment.basicInformation.twitterUrl" name="twitter-url" type="text" placeholder="XのURLを入力してください"
              :maxlength="10000" :validation-rules="{ url: { require_protocol: ['http', 'https'] }, max: 10000 }"
              :styles="{ width: '720px', 'max-width': '720px' }")
              template(#keyName)
                img.sns-icon(src="@/assets/sns-icon/x.png")
            FormInput(v-model="waiterRecruitment.basicInformation.facebookUrl" name="facebook-url" type="text" placeholder="FacebookのURLを入力してください" 
              :maxlength="10000" :validation-rules="{ url: { require_protocol: ['http', 'https'] }, max: 10000 }"
              :styles="{ width: '720px', 'max-width': '720px' }")
              template(#keyName)
                img.sns-icon(src="@/assets/sns-icon/facebook.png")
            FormInput(v-model="waiterRecruitment.basicInformation.instagramUrl" name="instagram-url" type="text" placeholder="InstagramのURLを入力してください"
              :maxlength="10000" :validation-rules="{ url: { require_protocol: ['http', 'https'] }, max: 10000 }"
              :styles="{ width: '720px', 'max-width': '720px' }")
              template(#keyName)
                img.sns-icon(src="@/assets/sns-icon/instagram.png")

      //- move to liff page
      .d-flex.justify-content-end.align-items-start.align-self-stretch.flex-fill(style="width: 170px;")
        button.btn.add-btn(type="button" @click="onMoveToWaiterRecruitment"
          :disabled="!existWaiterRecruitment" :class="{ 'disable': !existWaiterRecruitment }") 入所者募集ページ
    .mb-4

    //- follower
    .d-flex.flex-row.align-items-center.mb-2(v-if="_isOverWaiterBasicPlan")
      .sub-title.mr-2 フォロワー募集
      PublicSwitch(:value="waiterRecruitment.showSettings.follower" style="width: 70px;"
        @onSwitch="waiterRecruitment.showSettings.follower = !waiterRecruitment.showSettings.follower")
    .d-flex.flex-column.mb-2(v-else)
      .sub-title.mr-2 フォロワー募集
      .sub-title.error-message フォロワー募集はベーシックプラン以上で使用可能な機能です。
    .mb-4

    //- vacancyInformation
    .d-flex.flex-row.align-items-center.mb-2
      .sub-title.mr-2 空室状況
      PublicSwitch(:value="waiterRecruitment.showSettings.vacancyInformation" style="width: 70px;"
        @onSwitch="waiterRecruitment.showSettings.vacancyInformation = !waiterRecruitment.showSettings.vacancyInformation")
    .group(v-if="waiterRecruitment.showSettings.vacancyInformation")
      .group-item.p-2
        FormTextarea(v-model="waiterRecruitment.vacancyInformation" :name="'vacancy-information'" key-name="空室状況" placeholder="空室状況"
          :validation-rules="{ required: true,  max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }" required)
          template(v-slot:question)
            HelpIcon.ml-auto(:popoverId="'facility-setting-tab-vacancy-information-help'" title="URLリンクの書き方")
              template(v-slot:text)
                span クリックすると指定のURLにページ移動する「URLリンク」は以下のように記載ください。
                br
                br
                span [リンク表示名](URL)
                br
                br
                span 例：[HitomeQコネクト](https://qol.konicaminolta.jp/hitomeq/connect)
    .mb-4

    //- visitReception
    .d-flex.flex-row.align-items-center.mb-2
      .sub-title.mr-2 施設見学
      PublicSwitch(:value="waiterRecruitment.showSettings.visitReception" style="width: 70px;"
        @onSwitch="waiterRecruitment.showSettings.visitReception = !waiterRecruitment.showSettings.visitReception")
    .group(v-if="waiterRecruitment.showSettings.visitReception")
      .group-item.p-2
        FormTextarea(v-model="waiterRecruitment.visitReception.description" :name="'visit-reception-description'" key-name="説明文" placeholder="説明文"
          :validation-rules="{ max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }")
          template(v-slot:question)
            HelpIcon.ml-auto(:popoverId="'facility-setting-tab-visit-reception-help'" title="URLリンクの書き方")
              template(v-slot:text)
                span クリックすると指定のURLにページ移動する「URLリンク」は以下のように記載ください。
                br
                br
                span [リンク表示名](URL)
                br
                br
                span 例：[HitomeQコネクト](https://qol.konicaminolta.jp/hitomeq/connect)
    .mb-4

    //- articles
    .d-flex.flex-row.align-items-center.mb-2
      .sub-title.mr-2 掲載情報
      PublicSwitch(:value="waiterRecruitment.showSettings.articles" style="width: 70px;"
        @onSwitch="waiterRecruitment.showSettings.articles = !waiterRecruitment.showSettings.articles")
    .group.group-item.p-2(v-if="waiterRecruitment.showSettings.articles")
      .article.group-item.p-2.mb-2(v-for="(article, index) in waiterRecruitment.articles")
        FormInput(v-model="article.title" :name="'article-title-' + index" key-name="タイトル" type="text" placeholder="タイトル"
          :maxlength="100" :validation-rules="{ required: true, max: 100 }" :styles="{ width: '704px', 'max-width': '704px'  }" required)
        FormTextarea(v-model="article.content" :name="'article-content-' + index" key-name="本文" placeholder="本文を記載してください"
          :validation-rules="{ required: true, max: 5000 }" :maxlength="5000" :styles="{ maxWidth: '704px', width: '704px', minHeight: '160px' }" required)
          template(v-slot:question)
            HelpIcon.ml-auto(:popoverId="'facility-setting-tab-articles-help-' + index" title="URLリンクの書き方")
              template(v-slot:text)
                span クリックすると指定のURLにページ移動する「URLリンク」は以下のように記載ください。
                br
                br
                span [リンク表示名](URL)
                br
                br
                span 例：[HitomeQコネクト](https://qol.konicaminolta.jp/hitomeq/connect)
        .buttons.d-flex.flex-row.justify-content-end
          button.btn.group-add-btn(@click="onDeleteArticle(index)") 削除
      .buttons.d-flex.flex-row.justify-content-end
        button.btn.group-add-btn(@click="onAddArticle" :class="{ 'disable': _disableAddArticleButton }" :disabled="_disableAddArticleButton") 追加
    .mb-4

    //- media
    .d-flex.flex-row.align-items-center.mb-2
      .sub-title.mr-2 画像・動画情報
      PublicSwitch(:value="waiterRecruitment.showSettings.media" style="width: 70px;"
        @onSwitch="waiterRecruitment.showSettings.media = !waiterRecruitment.showSettings.media")
    .group.group-item.p-2(v-if="waiterRecruitment.showSettings.media")
      .media-files.group-item.p-2.mb-2(v-for="(media, index) in mediaFiles")
        FormFile(v-model="media.file" :name="'media-' + index" key-name="ファイル" :showDragAndDrop="false" :file-name.sync="media.name"
          width="700px" height="32px" mimetype="image/jpeg, image/png, video/mp4, video/quicktime" :validationRules="getMediaValidationRules(media)"
          @input="inputMedia(media)" required)
        FormTextarea(v-model="media.description" :name="'media-description' + index" key-name="説明文" placeholder="説明文を記載してください"
          :validation-rules="{ max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '704px', width: '704px', minHeight: '100px' }")
          template(v-slot:question)
            HelpIcon.ml-auto(:popoverId="'facility-setting-tab-media-help-' + index" title="URLリンクの書き方")
              template(v-slot:text)
                span クリックすると指定のURLにページ移動する「URLリンク」は以下のように記載ください。
                br
                br
                span [リンク表示名](URL)
                br
                br
                span 例：[HitomeQコネクト](https://qol.konicaminolta.jp/hitomeq/connect)
        .buttons.d-flex.flex-row.justify-content-end
          button.btn.preview-btn.mr-2(:disabled="disablePreviewButton(media.file)" :class="{ 'disable': disablePreviewButton(media.file) }"
            @click="onPreview(media.file)") プレビュー
          button.btn.group-add-btn(@click="onDeleteMedia(index)") 削除
      .buttons.d-flex.flex-row.justify-content-end
        button.btn.group-add-btn(@click="onAddMedia" :class="{ 'disable': _disableAddMediaButton }" :disabled="_disableAddMediaButton") 追加
    .mb-4

    //- usageFeesType
    .d-flex.flex-row.align-items-center.mb-2
      .sub-title.mr-2 料金シミュレーション
      PublicSwitch(:value="waiterRecruitment.showSettings.usageFees" style="width: 70px;"
        @onSwitch="waiterRecruitment.showSettings.usageFees = !waiterRecruitment.showSettings.usageFees")
    .usage-fees-group.group-item.p-2(v-if="waiterRecruitment.showSettings.usageFees")
      FormInputSelect(v-model="waiterRecruitment.usageFeesType" name="usage-fees-type" key-name="料金シミュレーションタイプ"
        :options="usageFeesTypeOptions" :styles="{ 'max-width': '540px' }")

      FormTextarea(v-model="waiterRecruitment.usageFeesInformation" name="usage-fees-information" key-name="説明文"
        placeholder="例：条件を選択すると、施設の月額使用料の概算が分かります。"
        :validation-rules="{ max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '704px', width: '704px', minHeight: '100px' }")
          template(v-slot:question)
            HelpIcon.ml-auto(popoverId="usage-fees-information-help" title="URLリンクの書き方")
              template(v-slot:text)
                span クリックすると指定のURLにページ移動する「URLリンク」は以下のように記載ください。
                br
                br
                span [リンク表示名](URL)
                br
                br
                span 例：[HitomeQコネクト](https://qol.konicaminolta.jp/hitomeq/connect)

      .tokuyo(v-if="waiterRecruitment.usageFeesType == 1 && usageFeesTokuyo")
        .sub-title.mb-2 料金シミュレーション（特養タイプ）
        .group-item.p-2
          UsageFeesTokuyoLivingCostsTable(v-model="usageFeesTokuyo.livingCosts" :facility="value")
          .mb-2
          UsageFeesTokuyoFoodCostsTable(v-model="usageFeesTokuyo.foodCosts")
          .mb-2
          UsageFeesTokuyoCareInsuranceServiceCostsTable(v-model="usageFeesTokuyo.careInsuranceServiceCosts" :facility="value")
          .mb-2

          .d-flex.flex-row.align-items-center.mb-2
            .sub-title.mr-1 介護保険加算（1割負担の金額、1ヶ月分）
            span.validation-label 必須
          .d-flex.flex-row.align-items-center
            b-form-input.mr-1(v-model.number="usageFeesTokuyo.careInsuranceAddition"
              :name="'usage-fees-tokuyo-living-costs-care-insurance-addition'"
              :maxlength="10" :class="[ { noinput: !usageFeesTokuyo.careInsuranceAddition } ]"
              v-validate="{ required: true, max: 10 }" data-vv-as="介護保険加算" :style="{ 'width':'120px' }")
            span 円
          .error-messages.mt-2(v-for="error in errors.collect('usage-fees-tokuyo-living-costs-care-insurance-addition')")
            .error-message {{ error }}
          .mb-4

          .d-flex.flex-row.align-items-center.mb-2
            .sub-title.mr-1 実費費用（1ヶ月分）
            span.validation-label 必須
          .d-flex.flex-row.align-items-center
            b-form-input.mr-1(v-model.number="usageFeesTokuyo.actualCost"
              :name="'usage-fees-tokuyo-living-costs-actual-cost'"
              :maxlength="10" :class="[ { noinput: !usageFeesTokuyo.actualCost } ]"
              v-validate="{ required: true, max: 10 }" data-vv-as="実費費用" :style="{ 'width':'120px' }")
            span 円
          .error-messages.mt-2(v-for="error in errors.collect('usage-fees-tokuyo-living-costs-actual-cost')")
            .error-message {{ error }}

      .group-home(v-if="waiterRecruitment.usageFeesType == 4 && usageFeesGroupHome")
        .sub-title.mb-2 料金シミュレーション（グループホームタイプ）
        .group-item.p-2
          UsageFeesGroupHomeAccommodationCostsTable(v-model="usageFeesGroupHome.nonCoveredAccommodationCosts" :facility="value")
          .mb-2
          UsageFeesGroupHomeInsuredServiceCostsTable(v-model="usageFeesGroupHome.insuredServiceCosts" :facility="value")
          .mb-2

          .d-flex.flex-row.align-items-center.mb-2
            .sub-title.mr-1 実費費用（1ヶ月分）
            span.validation-label 必須
          .d-flex.flex-row.align-items-center
            b-form-input.mr-1(v-model.number="usageFeesGroupHome.actualCost"
              :name="'usage-fees-group-home-actual-cost'"
              :maxlength="10" :class="[ { noinput: !usageFeesGroupHome.actualCost } ]"
              v-validate="{ required: true, max: 10 }" data-vv-as="実費費用" :style="{ 'width':'120px' }")
            span 円
          .error-messages.mt-2(v-for="error in errors.collect('usage-fees-group-home-actual-cost')")
            .error-message {{ error }}

      .only-paymentrate(v-if="waiterRecruitment.usageFeesType == 2 && usageFeesOnlyPaymentRate")
        .sub-title.mb-2 料金シミュレーション（自立・負担割合変動タイプ）
        .group-item.p-2
          UsageFeesOnlyPaymentRateTable(v-model="usageFeesOnlyPaymentRate" :facility="value")

      .only-upper-and-lower(v-if="waiterRecruitment.usageFeesType == 3 && usageFeesOnlyUpperAndLower")
        .sub-title.mb-2 料金シミュレーション（上限・下限タイプ）
        .group(style="width: 358px;")
          .group-item.p-2
            .d-flex.flex-row.align-items-center.mb-2
              .sub-title.mr-1 下限料金
              span.validation-label 必須
            .d-flex.flex-row.align-items-center
              b-form-input.mr-1(v-model.number="usageFeesOnlyUpperAndLower.minCosts"
                :name="'usage-fees-only-upper-and-lower-min-costs'"
                :maxlength="10" :class="[ { noinput: !usageFeesOnlyUpperAndLower.minCosts } ]"
                v-validate="{ required: true, max: 10 }" data-vv-as="下限料金" :style="{ 'width':'120px' }")
              span 円
            .error-messages.mt-2(v-for="error in errors.collect('usage-fees-only-upper-and-lower-min-costs')")
              .error-message {{ error }}
            .mb-4
            
            .d-flex.flex-row.align-items-center.mb-2
              .sub-title.mr-1 上限料金
              span.validation-label 必須
            .d-flex.flex-row.align-items-center
              b-form-input.mr-1(v-model.number="usageFeesOnlyUpperAndLower.maxCosts"
                :name="'usage-fees-only-upper-and-lower-max-costs'"
                :maxlength="10" :class="[ { noinput: !usageFeesOnlyUpperAndLower.maxCosts } ]"
                v-validate="{ required: true, max: 10 }" data-vv-as="上限料金" :style="{ 'width':'120px' }")
              span 円
            .error-messages.mt-2(v-for="error in errors.collect('usage-fees-only-upper-and-lower-max-costs')")
              .error-message {{ error }}
    .mb-4

    //- documents
    .d-flex.flex-row.align-items-center.mb-2
      .sub-title.mr-2 資料
      PublicSwitch(:value="waiterRecruitment.showSettings.documents" style="width: 70px;"
        @onSwitch="waiterRecruitment.showSettings.documents = !waiterRecruitment.showSettings.documents")
    .group.group-item.p-2(v-if="waiterRecruitment.showSettings.documents")
      .document.group-item.p-2.mb-2(v-for="(document, index) in documents")
        FormFile(v-model="document.file" :name="'document-' + index + '-file'" key-name="ファイル" :showDragAndDrop="false" :file-name.sync="document.name"
          width="700px" mimetype="application/pdf" :validationRules="{ required: true, file_size: 10, pdf_document: true }" height="32px" 
          @input="inputDocument(document)" required)
        FormInput(v-model="document.linkText" :name="'document-' + index + '-link-text'" key-name="リンクテキスト" type="text" placeholder="リンクテキスト"
          :maxlength="100" :validation-rules="{ required: true, max: 100 }" :styles="{ width: '700px', 'max-width': '700px'  }" required)
        .buttons.d-flex.flex-row.justify-content-end
          button.btn.preview-btn.mr-2(@click="onPreview(document.file)") プレビュー
          button.btn.group-add-btn(@click="onDeleteDocument(index)") 削除
      .buttons.d-flex.flex-row.justify-content-end.mt-2
        button.btn.group-add-btn(@click="onAddDocument" :class="{ 'disable': _disableAddDocumentButton }" :disabled="_disableAddDocumentButton") 追加
    .mb-4

    //- faq
    .d-flex.flex-row.align-items-center.mb-2
      .sub-title.mr-2 よくある質問
      PublicSwitch(:value="waiterRecruitment.showSettings.faqs" style="width: 70px;"
        @onSwitch="waiterRecruitment.showSettings.faqs = !waiterRecruitment.showSettings.faqs")
    .group.group-item.p-2(v-if="waiterRecruitment.showSettings.faqs")
      .faq.group-item.p-2.mb-2(v-for="(faq, index) in waiterRecruitment.faqs")
        FormInput(v-model="faq.question" :name="'faq-question-' + index" key-name="質問" type="text" placeholder="質問"
          :maxlength="100" :validation-rules="{ required: true, max: 100 }" :styles="{ width: '700px', 'max-width': '700px' }" required)
        FormTextarea(v-model="faq.answer" :name="'faq-answer-' + index" key-name="回答" placeholder="回答"
          :validation-rules="{ required: true, max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '700px', width: '700px', minHeight: '160px' }" required)
          template(v-slot:question)
            HelpIcon.ml-auto(:popoverId="'facility-setting-tab-faqs-help-' + index" title="URLリンクの書き方")
              template(v-slot:text)
                span クリックすると指定のURLにページ移動する「URLリンク」は以下のように記載ください。
                br
                br
                span [リンク表示名](URL)
                br
                br
                span 例：[HitomeQコネクト](https://qol.konicaminolta.jp/hitomeq/connect)
        .buttons.d-flex.flex-row.justify-content-end
          button.btn.group-add-btn(@click="onDeleteFaq(index)") 削除
      .buttons.d-flex.flex-row.justify-content-end.mt-2
        button.btn.group-add-btn(@click="onAddFaq" :class="{ 'disable': _disableAddFaqButton }" :disabled="_disableAddFaqButton") 追加
    .mb-4

    //- contact
    .d-flex.flex-row.align-items-center.mb-2
      .sub-title.mr-2 お問い合わせ
      PublicSwitch(:value="waiterRecruitment.showSettings.contact" style="width: 70px;"
        @onSwitch="waiterRecruitment.showSettings.contact = !waiterRecruitment.showSettings.contact")
    .group(v-if="waiterRecruitment.showSettings.contact")
      .group-item.p-2
        FormTextarea(v-model="waiterRecruitment.contact.description" :name="'contact-description'" key-name="説明文" placeholder="説明文"
          :validation-rules="{ max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }")
          template(v-slot:question)
            HelpIcon.ml-auto(:popoverId="'facility-setting-tab-contact-help'" title="URLリンクの書き方")
              template(v-slot:text)
                span クリックすると指定のURLにページ移動する「URLリンク」は以下のように記載ください。
                br
                br
                span [リンク表示名](URL)
                br
                br
                span 例：[HitomeQコネクト](https://qol.konicaminolta.jp/hitomeq/connect)
        FormInput(v-model="waiterRecruitment.contact.tel" name="contact-tel" key-name="電話番号" type="text" placeholder="電話番号"
          :maxlength="100" :validation-rules="{ tel: true, max: 14 }" :styles="{ width: '720px', 'max-width': '720px' }")

  .box-footer.register-footer
    ValidationAlert(v-model="showValidationAlert")
    .buttons.m-0(v-if="waiterRecruitment != null")
      button.btn.update-btn(v-if="waiterRecruitment.updated == -1" @click="onRegister" type="button") 登録
      button.btn.update-btn(v-else @click="onUpdate" type="button") 更新

  RelativeLoading(:isBusy="isBusy" :message="loadingMessage")
  OkCancelModal(v-model="showRegisterModal" :title="registerModalTitle" @ok="registerWaiterRecruitment(waiterRecruitment)")
  OkCancelModal(v-model="showUpdateModal" :title="updateModalTitle" @ok="updateWaiterRecruitment(waiterRecruitment)")

  ImageModal(v-model="showImageModal" :imageUrl="imageModalUrl")
  Mp4Modal(v-model="showMp4Modal" :url="mp4ModalUrl")
  MovModal(v-model="showMovModal" :url="movModalUrl")
  PdfModal(v-model="showPdfModal" :pdfUrl="pdfModalUrl")
</template>

<script lang="ts">
import { Component, Inject, Prop, Watch, Vue } from "vue-property-decorator";

import { userStore } from "@/store/store";
import Setting from "../../../../public/setting.json";

import SystemError from "@/commons/models/SystemError";
import CustomValidate from "@/commons/utils/CustomValidate";

import { FacilityGetModel } from "@/commons/services/Facilities";
import WaiterRecruitmentsService, {
  WaiterRecruitmentsGetModel,
  FacilityType,
  Media,
  UsageFeesOnlyPaymentRate,
  UsageFeesOnlyUpperAndLower,
  UsageFeesTokuyo,
  UsageFeesType,
  Document,
  BasicInformation,
  Article,
  ShowSetting,
  Faq,
  VisitReception,
  Contact,
  HeaderImage,
  ExtNursingCare,
  ExtCareLevel,
  ExtPaymentCeiling,
  UsageFeesGroupHome,
  ExtAccommodationCost,
  ExtInsuredServiceCost
} from "@/commons/services/WaiterRecruitments";
import S3UrlService from "@/commons/services/S3Url";
import { WaiterServicePlanType } from "@/commons/services/WaiterServicePlans";

import HelpIcon from "@/pc/basics/HelpIcon.vue";
import RelativeLoading from "@/pc/basics/RelativeLoading.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import ImageModal from "@/pc/basics/ImageModal.vue";
import Mp4Modal from "@/pc/basics/Mp4Modal.vue";
import MovModal from "@/pc/basics/MovModal.vue";
import PdfModal from "@/pc/basics/PdfModal.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import FormFile from "@/pc/components/forms/FormFile.vue";
import PublicSwitch from "@/pc/basics/PublicSwitch.vue";
import UsageFeesTokuyoLivingCostsTable from "@/pc/containers/waiters/UsageFeesTokuyoLivingCostsTable.vue";
import UsageFeesTokuyoFoodCostsTable from "@/pc/containers/waiters/UsageFeesTokuyoFoodCostsTable.vue";
import UsageFeesTokuyoCareInsuranceServiceCostsTable from "@/pc/containers/waiters/UsageFeesTokuyoCareInsuranceServiceCostsTable.vue";
import UsageFeesGroupHomeAccommodationCostsTable from "@/pc/containers/waiters/UsageFeesGroupHomeAccommodationCostsTable.vue";
import UsageFeesGroupHomeInsuredServiceCostsTable from "@/pc/containers/waiters/UsageFeesGroupHomeInsuredServiceCostsTable.vue";
import UsageFeesOnlyPaymentRateTable from "@/pc/containers/waiters/UsageFeesOnlyPaymentRateTable.vue";

/**
 * ### 施設情報(登録者・待機者向け)タブコンポーネント
 */
@Component({
  components: {
    HelpIcon,
    RelativeLoading,
    OkCancelModal,
    ImageModal,
    Mp4Modal,
    MovModal,
    PdfModal,
    ValidationAlert,
    FormInput,
    FormInputSelect,
    FormTextarea,
    FormFile,
    PublicSwitch,
    UsageFeesTokuyoLivingCostsTable,
    UsageFeesTokuyoFoodCostsTable,
    UsageFeesTokuyoCareInsuranceServiceCostsTable,
    UsageFeesGroupHomeAccommodationCostsTable,
    UsageFeesGroupHomeInsuredServiceCostsTable,
    UsageFeesOnlyPaymentRateTable
  },
  $_veeValidate: { validator: "new" }
})
export default class FacilitySettingTab extends Vue {
  /** 待機者募集ページ */
  @Inject("WaiterRecruitmentsService") waiterRecruitmentsService!: WaiterRecruitmentsService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;

  @Prop()
  value!: FacilityGetModel;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 登録確認モーダル表示可否 */
  showRegisterModal: boolean = false;
  /** 登録確認モーダルタイトル */
  registerModalTitle: string = "";
  /** 更新確認モーダル表示可否 */
  showUpdateModal: boolean = false;
  /** 更新確認モーダルタイトル */
  updateModalTitle: string = "";

  /** type:file の画像プレビューモーダル表示可否 */
  showImageModal: boolean = false;
  /** type:file の画像プレビューモーダルで表示する対象のURL */
  imageModalUrl: string = "";
  /** type:file の画像プレビューモーダル表示可否 */
  showMp4Modal: boolean = false;
  /** type:file の画像プレビューモーダルで表示する対象のURL */
  mp4ModalUrl: string = "";
  /** type:file の画像プレビューモーダル表示可否 */
  showMovModal: boolean = false;
  /** type:file の画像プレビューモーダルで表示する対象のURL */
  movModalUrl: string = "";
  /** type:file のPDFプレビューモーダル表示可否 */
  showPdfModal: boolean = false;
  /** type:file のPDFプレビューモーダルで表示する対象のURL */
  pdfModalUrl: string = "";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 待機者募集ページ */
  waiterRecruitment: WaiterRecruitmentsGetModel | null = null;
  /** 待機者募集ページの存在 */
  existWaiterRecruitment: boolean = false;
  /** ヘッダー画像1ファイル */
  headerImage1: File | null = null;
  /** ヘッダー画像1S3Url */
  headerImageS3Url1: string = "";
  /** ヘッダー画像1ファイルUrl */
  headerImageUrl1: string = "";
  /** ヘッダー画像1ファイル名 */
  headerImageName1: string = "";
  /** ヘッダー画像2ファイル */
  headerImage2: File | null = null;
  /** ヘッダー画像2S3Url */
  headerImageS3Url2: string = "";
  /** ヘッダー画像2ファイルUrl */
  headerImageUrl2: string = "";
  /** ヘッダー画像2ファイル名 */
  headerImageName2: string = "";
  /** ヘッダー画像3ファイル */
  headerImage3: File | null = null;
  /** ヘッダー画像3S3Url */
  headerImageS3Url3: string = "";
  /** ヘッダー画像3ファイルUrl */
  headerImageUrl3: string = "";
  /** ヘッダー画像3ファイル名 */
  headerImageName3: string = "";
  /** 施設種類選択項目 */
  facilityTypeOptions: Array<{ value: number | string; label: string }> = [
    { value: FacilityType.TOKUYO, label: "特別養護老人ホーム" },
    { value: FacilityType.KAIGO_HOKEN, label: "介護老人保健施設" },
    { value: FacilityType.GROUP_HOME, label: "グループホーム" },
    { value: FacilityType.CARE_HOUSE, label: " ケアハウス" },
    { value: FacilityType.KAIGO_YUURYOU, label: "介護付き有料老人ホーム" },
    { value: FacilityType.JYUUTAKU_YUURYOU, label: "住宅型有料老人ホーム" },
    { value: FacilityType.SERVICE_JYUUTAKU, label: "サービス付き高齢者向け住宅" }
  ];
  /** 画像・動画情報 */
  mediaFiles: Array<WaiterRecruitmentMedia> = [];
  /** 料金シミュレーション種別選択項目 */
  usageFeesTypeOptions: Array<{ value: number | string; label: string }> = [
    { value: UsageFeesType.TOKUYOU, label: "特養タイプ" },
    { value: UsageFeesType.GROUP_HOME, label: "グループホームタイプ" },
    { value: UsageFeesType.ONLY_PAYMENTRATE, label: "自立・負担割合変動タイプ" },
    { value: UsageFeesType.ONLY_UPPER_AND_LOWER, label: "上限・下限タイプ" }
  ];
  /** 料金シミュレーション(特養タイプ) */
  usageFeesTokuyo: UsageFeesTokuyo | null = null;
  /** 料金シミュレーション（グループホームタイプ） */
  usageFeesGroupHome: UsageFeesGroupHome | null = null;
  /** 料金シミュレーション(自立・負担割合変動タイプ) */
  usageFeesOnlyPaymentRate: UsageFeesOnlyPaymentRate | null = null;
  /** 料金シミュレーション(上限・下限タイプ) */
  usageFeesOnlyUpperAndLower: UsageFeesOnlyUpperAndLower | null = null;
  /** 資料 */
  documents: Array<WaiterRecruitmentDocument> = [];

  /** ### プラン(待機者)がベーシック以上かを返す */
  get _isOverWaiterBasicPlan(): boolean {
    const planType: WaiterServicePlanType = userStore.facility.waiterServicePlanType;

    if (WaiterServicePlanType.BASIC <= planType) {
      return true;
    } else {
      return false;
    }
  }

  @Watch("headerImageUrl1")
  changeHeaderImage1Url(): void {
    if (this.headerImageUrl1) {
      this.headerImage1 = this.convertImageUrlToFile(this.headerImageUrl1, this.headerImageName1);
    } else {
      this.headerImage1 = null;
    }
    this.headerImageS3Url1 = "";
    return;
  }

  @Watch("headerImageUrl2")
  changeHeaderImage2Url(): void {
    if (this.headerImageUrl2) {
      this.headerImage2 = this.convertImageUrlToFile(this.headerImageUrl2, this.headerImageName2);
    } else {
      this.headerImage2 = null;
    }
    this.headerImageS3Url2 = "";
    return;
  }

  @Watch("headerImageUrl3")
  changeHeaderImage3Url(): void {
    if (this.headerImageUrl3) {
      this.headerImage3 = this.convertImageUrlToFile(this.headerImageUrl3, this.headerImageName3);
    } else {
      this.headerImage3 = null;
    }
    this.headerImageS3Url3 = "";
    return;
  }

  public convertImageUrlToFile(imageUrl: string, fileName: string): File {
    const bin = atob(imageUrl.replace(/^.*,/, ""));

    let buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }

    const file = new File([buffer.buffer], fileName, { type: "image/jpeg" });

    return file;
  }

  get _value(): FacilityGetModel {
    return this.value;
  }

  set _value(newValue: FacilityGetModel) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### 掲載情報の追加ボタンの表示可否
   */
  get _disableAddArticleButton(): boolean {
    if (this.waiterRecruitment != null) {
      if (50 <= this.waiterRecruitment.articles.length) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  /**
   * ### 画像・動画情報の追加ボタンの表示可否
   */
  get _disableAddMediaButton(): boolean {
    if (this.waiterRecruitment != null) {
      if (50 <= this.waiterRecruitment.media.length) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  /**
   * ### 資料の追加ボタンの表示可否
   */
  get _disableAddDocumentButton(): boolean {
    if (this.waiterRecruitment != null) {
      if (50 <= this.documents.length) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  /**
   * ### よくある質問の追加ボタンの表示可否
   */
  get _disableAddFaqButton(): boolean {
    if (this.waiterRecruitment != null) {
      if (50 <= this.waiterRecruitment.faqs.length) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  /**
   * ### 画面情報をリフレッシュする
   *
   * - 親コンポーネントから呼び出される
   */
  public async refresh(): Promise<void> {
    await this.createView();
    return;
  }

  public resetFiles(): void {
    this.mediaFiles = [];
    this.documents = [];
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public created(): void {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    // 待機者募集ページを取得して存在すればその情報を使用し、存在しなければ初期情報を作成する
    const waiterRecruitment: WaiterRecruitmentsGetModel | null = await this.getWaiterRecruitment();
    if (waiterRecruitment == null) {
      this.waiterRecruitment = this.createInitializedWaiterRecruitment();
      this.mediaFiles = [];
      this.documents = [];
      this.existWaiterRecruitment = false;
    } else {
      this.waiterRecruitment = waiterRecruitment;
      for (let i = 0; i < waiterRecruitment.basicInformation.headerImages.length; i++) {
        const headerImage = await this.restorationHeaderImage(waiterRecruitment.basicInformation.headerImages[i]);
        if (i == 0) {
          this.headerImageName1 = headerImage.name;
          this.headerImageS3Url1 = headerImage.url;
          this.headerImage1 = headerImage.file;
        } else if (i == 1) {
          this.headerImageName2 = headerImage.name;
          this.headerImageS3Url2 = headerImage.url;
          this.headerImage2 = headerImage.file;
        } else if (i == 2) {
          this.headerImageName3 = headerImage.name;
          this.headerImageS3Url3 = headerImage.url;
          this.headerImage3 = headerImage.file;
        }
      }
      this.mediaFiles = await this.restorationMedia(waiterRecruitment.media);
      this.documents = await this.restorationDocuments(waiterRecruitment.documents);
      this.existWaiterRecruitment = true;
      this.waiterRecruitment.showSettings.follower = this._isOverWaiterBasicPlan ? waiterRecruitment.showSettings.follower : false;
    }

    // 料金シミュレーションの情報はパターンが存在するので、該当するパターンの場合は復元し、該当しないものは初期情報を作成する
    switch (this.waiterRecruitment.usageFeesType) {
      case UsageFeesType.TOKUYOU: {
        this.usageFeesTokuyo = this.restoreUsageFeesTokuyo(this.waiterRecruitment.usageFees as UsageFeesTokuyo);
        this.usageFeesGroupHome = this.createInitializedFeesGroupHome();
        this.usageFeesOnlyPaymentRate = this.createInitializedFeesOnlyPaymentRate();
        this.usageFeesOnlyUpperAndLower = this.createInitializedFeesOnlyUpperAndLower();
        break;
      }
      case UsageFeesType.GROUP_HOME: {
        this.usageFeesTokuyo = this.createInitializedFeesTokuyo();
        this.usageFeesGroupHome = this.restoreUsageFeesGroupHome(this.waiterRecruitment.usageFees as UsageFeesGroupHome);
        this.usageFeesOnlyPaymentRate = this.createInitializedFeesOnlyPaymentRate();
        this.usageFeesOnlyUpperAndLower = this.createInitializedFeesOnlyUpperAndLower();
        break;
      }
      case UsageFeesType.ONLY_PAYMENTRATE: {
        this.usageFeesTokuyo = this.createInitializedFeesTokuyo();
        this.usageFeesGroupHome = this.createInitializedFeesGroupHome();
        this.usageFeesOnlyPaymentRate = this.restoreUsageFeesOnlyPaymentRate(this.waiterRecruitment.usageFees as UsageFeesOnlyPaymentRate);
        this.usageFeesOnlyUpperAndLower = this.createInitializedFeesOnlyUpperAndLower();
        break;
      }
      case UsageFeesType.ONLY_UPPER_AND_LOWER: {
        this.usageFeesTokuyo = this.createInitializedFeesTokuyo();
        this.usageFeesGroupHome = this.createInitializedFeesGroupHome();
        this.usageFeesOnlyPaymentRate = this.createInitializedFeesOnlyPaymentRate();
        this.usageFeesOnlyUpperAndLower = this.waiterRecruitment.usageFees as UsageFeesOnlyUpperAndLower;
        break;
      }
      // 待機者募集ページが存在しない場合は全て初期情報を使用する
      default: {
        this.usageFeesTokuyo = this.createInitializedFeesTokuyo();
        this.usageFeesGroupHome = this.createInitializedFeesGroupHome();
        this.usageFeesOnlyPaymentRate = this.createInitializedFeesOnlyPaymentRate();
        this.usageFeesOnlyUpperAndLower = this.createInitializedFeesOnlyUpperAndLower();
        break;
      }
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### 待機者募集ページを取得する
   */
  public async getWaiterRecruitment(): Promise<WaiterRecruitmentsGetModel | null> {
    try {
      const response: WaiterRecruitmentsGetModel = await this.waiterRecruitmentsService.get(userStore);

      return response;
    } catch (error) {
      const systemError: SystemError = error as SystemError;
      // 404の場合でもエラーではないのでnullを返す
      if (systemError.statusCode == 404) {
        return null;
      } else {
        throw error;
      }
    }
  }

  /**
   * ### 待機者募集ページの初期データを作成する
   */
  public createInitializedWaiterRecruitment(): WaiterRecruitmentsGetModel {
    return {
      facilityId: userStore.loginUser.facilityId,

      /** 基本情報 */
      basicInformation: {
        /** 施設名 */
        facilityName: "",
        /** ヘッダー画像 */
        headerImages: [],
        /** 施設種別 */
        facilityType: null,
        /** 施設住所 */
        address: "",
        /** 施設URL */
        facilityUrl: "",
        /** 運営法人 */
        corporationName: "",
        /** 電話番号 */
        tel: "",
        /** Twitter */
        twitterUrl: "",
        /** Facebook */
        facebookUrl: "",
        /** Instagram */
        instagramUrl: "",
        /** 会社HPのURL */
        corporationUrl: undefined
      },
      /** 空室状況 */
      vacancyInformation: "",
      /** 施設見学 */
      visitReception: {
        description: ""
      },
      /** 掲載情報 */
      articles: [],
      /** 画像・動画情報 */
      media: [],
      /** 料金シミュレーション種別 */
      usageFeesType: UsageFeesType.UNKNOWN,
      /** 料金シミュレーション */
      usageFees: null,
      /** 料金シミュレーション説明文 */
      usageFeesInformation: "条件を選択すると、施設の月額使用料の概算が分かります。",
      /** 資料 */
      documents: [],
      /** よくある質問 */
      faqs: [],
      /** お問い合わせ */
      contact: {
        description: "",
        tel: ""
      },
      /** 各コンテンツの表示可否 */
      showSettings: {
        visitReception: false,
        articles: false,
        media: false,
        follower: false,
        vacancyInformation: false,
        usageFees: false,
        documents: false,
        faqs: false,
        contact: false
      },

      updated: -1,
      created: -1
    };
  }

  /**
   * ### ヘッダー画像情報を復元する
   */
  public async restorationHeaderImage(headerImage: HeaderImage): Promise<WaiterRecruitmentBasicInformatnHeaderImage> {
    const file: File = await this.getS3File(headerImage.url, headerImage.name);
    return {
      file: file,
      name: headerImage.name,
      url: headerImage.url,
      type: headerImage.type
    };
  }

  /**
   * ### 画像・動画情報を復元する
   */
  public async restorationMedia(mediaArray: Array<Media>): Promise<Array<WaiterRecruitmentMedia>> {
    let mediaFiles: Array<WaiterRecruitmentMedia> = [];

    for (const media of mediaArray) {
      const file: File = await this.getS3File(media.url, media.name);
      mediaFiles.push({
        file,
        name: media.name,
        url: media.url,
        type: media.type,
        description: media.description
      });
    }

    return mediaFiles;
  }

  /**
   * ### S3に格納されているFileを取得する
   */
  public async getS3File(url: string, fileName: string): Promise<File> {
    const response: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, url, fileName);
    return response;
  }

  /**
   * ### 資料を復元する
   */
  public async restorationDocuments(documents: Array<Document>): Promise<Array<WaiterRecruitmentDocument>> {
    let documentFiles: Array<WaiterRecruitmentDocument> = [];

    for (const document of documents) {
      const file: File = await this.getS3File(document.url, document.name);
      documentFiles.push({
        file,
        linkText: document.linkText,
        name: document.name,
        url: document.url
      });
    }

    return documentFiles;
  }

  private restoreUsageFeesTokuyo(usageFees: UsageFeesTokuyo): UsageFeesTokuyo {
    usageFees = this.restoreLivingCosts(usageFees, userStore.facility);
    usageFees = this.restoreCareInsuranceServiceCosts(usageFees, userStore.facility);
    return usageFees;
  }

  /**
   * ### 居住費の復元
   *
   * - 登録データと施設の待機者管理の部屋設定を比較して画面表示用に復元する
   */
  private restoreLivingCosts(usageFees: UsageFeesTokuyo, facility: FacilityGetModel): UsageFeesTokuyo {
    // データが登録されていない場合は初期化する
    if (!usageFees.careInsuranceServiceCosts) {
      return this.createInitializedFeesTokuyo();
    }

    // customRecruitmentRoomの登録データがない場合は初期化する
    if (!usageFees.livingCosts.customRecruitmentRoom) {
      const customRecruitmentRoom: Array<ExtPaymentCeiling> = [];
      for (const room of facility.customRecruitmentRoom) {
        if (room.use) {
          customRecruitmentRoom.push({
            paymentCeiling_1: null,
            paymentCeiling_2: null,
            paymentCeiling_3_1: null,
            paymentCeiling_3_2: null,
            paymentCeiling_4: null,
            id: room.id,
            roomName: room.name
          });
        }
      }
      usageFees.livingCosts.customRecruitmentRoom = customRecruitmentRoom;
    }
    // 登録データが存在する場合は画面表示用の復元を行う
    else {
      // カスタム部屋の情報が既に登録されているとVueに値がキャッシュされてしまい、除外したカスタム部屋が表示されてしまう
      // 既存の情報を増減させるのではなく、新しいプロパティにディープコピーしたデータを追加することでキャッシュさせないようにする
      const customRecruitmentRoom: Array<ExtPaymentCeiling> = [];

      /**
       * 登録データに存在して、施設情報の待機者管理の部屋設定(施設固有)に存在しないものを除外する
       */
      const customRoomsToUse = facility.customRecruitmentRoom ? facility.customRecruitmentRoom.filter((room) => room.use) : [];
      // facilities.customRecruitmentRoomをIDで検索しやすいようにSetに変換
      const facilityRoomIdsToUse = new Set(customRoomsToUse.map((room) => room.id));
      // 登録されたデータに存在してfacilities.customRecruitmentRoomに存在しない要素を削除
      // filterを使って、RoomIdsに含まれない要素を除外
      for (const room of usageFees.livingCosts.customRecruitmentRoom.filter((room) => facilityRoomIdsToUse.has(room.id))) {
        customRecruitmentRoom.push(JSON.parse(JSON.stringify(room)));
      }

      /**
       * 施設情報の待機者管理の部屋設定(施設固有)に存在して、登録データに存在しないものを除外する
       */
      const usageFeesRoomIds = new Set(usageFees.livingCosts.customRecruitmentRoom.map((room) => room.id));
      const roomsToAdd = facility.customRecruitmentRoom ? facility.customRecruitmentRoom.filter((room) => !usageFeesRoomIds.has(room.id)) : [];
      // 抽出した要素を登録データに初期値で追加
      for (const room of roomsToAdd) {
        if (room.use) {
          customRecruitmentRoom.push({
            paymentCeiling_1: null,
            paymentCeiling_2: null,
            paymentCeiling_3_1: null,
            paymentCeiling_3_2: null,
            paymentCeiling_4: null,
            id: room.id,
            roomName: room.name
          });
        }
      }

      const _usageFees: UsageFeesTokuyo = {
        ...usageFees,
        livingCosts: {
          ...usageFees.livingCosts,
          customRecruitmentRoom: customRecruitmentRoom // カスタム部屋だけ入れ替える
        }
      };
      return _usageFees;
    }

    return usageFees;
  }

  /**
   * ### 介護保険給付サービス利用料の復元
   *
   * - 登録データと施設の待機者管理の部屋設定を比較して画面表示用に復元する
   */
  private restoreCareInsuranceServiceCosts(usageFees: UsageFeesTokuyo, facility: FacilityGetModel): UsageFeesTokuyo {
    // データが登録されていない場合は初期化する
    if (!usageFees.careInsuranceServiceCosts) {
      return this.createInitializedFeesTokuyo();
    }

    // customRecruitmentRoomの登録データがない場合は初期化する
    if (!usageFees.careInsuranceServiceCosts.customRecruitmentRoom) {
      const customRecruitmentRoom: Array<ExtCareLevel> = [];
      for (const room of facility.customRecruitmentRoom) {
        if (room.use) {
          customRecruitmentRoom.push({
            careLevel_1: null,
            careLevel_2: null,
            careLevel_3: null,
            careLevel_4: null,
            careLevel_5: null,
            id: room.id,
            roomName: room.name
          });
        }
      }
      usageFees.careInsuranceServiceCosts.customRecruitmentRoom = customRecruitmentRoom;
    }
    // 登録データが存在する場合は画面表示用の復元を行う
    else {
      // カスタム部屋の情報が既に登録されているとVueに値がキャッシュされてしまい、除外したカスタム部屋が表示されてしまう
      // 既存の情報を増減させるのではなく、新しいプロパティにディープコピーしたデータを追加することでキャッシュさせないようにする
      const customRecruitmentRoom: Array<ExtCareLevel> = [];

      /**
       * 登録データに存在して、施設情報の待機者管理の部屋設定(施設固有)に存在しないものを除外する
       */
      const customRoomsToUse = facility.customRecruitmentRoom ? facility.customRecruitmentRoom.filter((room) => room.use) : [];
      // facilities.customRecruitmentRoomをIDで検索しやすいようにSetに変換
      const facilityRoomIdsToUse = new Set(customRoomsToUse.map((room) => room.id));
      // 登録されたデータに存在してfacilities.customRecruitmentRoomに存在しない要素を削除
      // filterを使って、RoomIdsに含まれない要素を除外
      for (const room of usageFees.careInsuranceServiceCosts.customRecruitmentRoom.filter((room) => facilityRoomIdsToUse.has(room.id))) {
        customRecruitmentRoom.push(JSON.parse(JSON.stringify(room)));
      }

      /**
       * 施設情報の待機者管理の部屋設定(施設固有)に存在して、登録データに存在しないものを除外する
       */
      const usageFeesRoomIds = new Set(usageFees.careInsuranceServiceCosts.customRecruitmentRoom.map((room) => room.id));
      const roomsToAdd = facility.customRecruitmentRoom ? facility.customRecruitmentRoom.filter((room) => !usageFeesRoomIds.has(room.id)) : [];

      // 抽出した要素を登録データに初期値で追加
      for (const room of roomsToAdd) {
        if (room.use) {
          customRecruitmentRoom.push({
            careLevel_1: null,
            careLevel_2: null,
            careLevel_3: null,
            careLevel_4: null,
            careLevel_5: null,
            id: room.id,
            roomName: room.name
          });
        }
      }

      const _usageFees: UsageFeesTokuyo = {
        ...usageFees,
        careInsuranceServiceCosts: {
          ...usageFees.careInsuranceServiceCosts,
          customRecruitmentRoom: customRecruitmentRoom // カスタム部屋だけ入れ替える
        }
      };

      return _usageFees;
    }

    return usageFees;
  }

  private restoreUsageFeesGroupHome(usageFees: UsageFeesGroupHome): UsageFeesGroupHome {
    usageFees = this.restoreAccommodationCosts(usageFees, userStore.facility);
    usageFees = this.restoreInsuredServiceCosts(usageFees, userStore.facility);
    return usageFees;
  }

  /**
   * ### 居住費の復元
   *
   * - 登録データと施設の待機者管理の部屋設定を比較して画面表示用に復元する
   */
  private restoreAccommodationCosts(usageFees: UsageFeesGroupHome, facility: FacilityGetModel): UsageFeesGroupHome {
    // データが登録されていない場合は初期化する
    if (!usageFees.nonCoveredAccommodationCosts) {
      return this.createInitializedFeesGroupHome();
    }

    // customRecruitmentRoomの登録データがない場合は初期化する
    if (!usageFees.nonCoveredAccommodationCosts.customRecruitmentRoom) {
      const customRecruitmentRoom: Array<ExtAccommodationCost> = [];
      for (const room of facility.customRecruitmentRoom) {
        if (room.use) {
          customRecruitmentRoom.push({
            rentCost: null,
            mealCost: null,
            managementCost: null,
            utilityCost: null,
            otherCost: null,
            id: room.id,
            roomName: room.name
          });
        }
      }
      usageFees.nonCoveredAccommodationCosts.customRecruitmentRoom = customRecruitmentRoom;
    }
    // 登録データが存在する場合は画面表示用の復元を行う
    else {
      // カスタム部屋の情報が既に登録されているとVueに値がキャッシュされてしまい、除外したカスタム部屋が表示されてしまう
      // 既存の情報を増減させるのではなく、新しいプロパティにディープコピーしたデータを追加することでキャッシュさせないようにする
      const customRecruitmentRoom: Array<ExtAccommodationCost> = [];

      /**
       * 登録データに存在して、施設情報の待機者管理の部屋設定(施設固有)に存在しないものを除外する
       */
      const customRoomsToUse = facility.customRecruitmentRoom ? facility.customRecruitmentRoom.filter((room) => room.use) : [];
      // facilities.customRecruitmentRoomをIDで検索しやすいようにSetに変換
      const facilityRoomIdsToUse = new Set(customRoomsToUse.map((room) => room.id));
      // 登録されたデータに存在してfacilities.customRecruitmentRoomに存在しない要素を削除
      // filterを使って、RoomIdsに含まれない要素を除外
      for (const room of usageFees.nonCoveredAccommodationCosts.customRecruitmentRoom.filter((room) => facilityRoomIdsToUse.has(room.id))) {
        customRecruitmentRoom.push(JSON.parse(JSON.stringify(room)));
      }

      /**
       * 施設情報の待機者管理の部屋設定(施設固有)に存在して、登録データに存在しないものを除外する
       */
      const usageFeesRoomIds = new Set(usageFees.nonCoveredAccommodationCosts.customRecruitmentRoom.map((room) => room.id));
      const roomsToAdd = facility.customRecruitmentRoom ? facility.customRecruitmentRoom.filter((room) => !usageFeesRoomIds.has(room.id)) : [];
      // 抽出した要素を登録データに初期値で追加
      for (const room of roomsToAdd) {
        if (room.use) {
          customRecruitmentRoom.push({
            rentCost: null,
            mealCost: null,
            managementCost: null,
            utilityCost: null,
            otherCost: null,
            id: room.id,
            roomName: room.name
          });
        }
      }

      const _usageFees: UsageFeesGroupHome = {
        ...usageFees,
        nonCoveredAccommodationCosts: {
          ...usageFees.nonCoveredAccommodationCosts,
          customRecruitmentRoom: customRecruitmentRoom // カスタム部屋だけ入れ替える
        }
      };
      return _usageFees;
    }

    return usageFees;
  }

  /**
   * ### 介護保険給付サービス利用料の復元
   *
   * - 登録データと施設の待機者管理の部屋設定を比較して画面表示用に復元する
   */
  private restoreInsuredServiceCosts(usageFees: UsageFeesGroupHome, facility: FacilityGetModel): UsageFeesGroupHome {
    // データが登録されていない場合は初期化する
    if (!usageFees.insuredServiceCosts) {
      return this.createInitializedFeesGroupHome();
    }

    // customRecruitmentRoomの登録データがない場合は初期化する
    if (!usageFees.insuredServiceCosts.customRecruitmentRoom) {
      const customRecruitmentRoom: Array<ExtInsuredServiceCost> = [];
      for (const room of facility.customRecruitmentRoom) {
        if (room.use) {
          customRecruitmentRoom.push({
            supportLevel_1: null,
            supportLevel_2: null,
            careLevel_1: null,
            careLevel_2: null,
            careLevel_3: null,
            careLevel_4: null,
            careLevel_5: null,
            id: room.id,
            roomName: room.name
          });
        }
      }
      usageFees.insuredServiceCosts.customRecruitmentRoom = customRecruitmentRoom;
    }
    // 登録データが存在する場合は画面表示用の復元を行う
    else {
      // カスタム部屋の情報が既に登録されているとVueに値がキャッシュされてしまい、除外したカスタム部屋が表示されてしまう
      // 既存の情報を増減させるのではなく、新しいプロパティにディープコピーしたデータを追加することでキャッシュさせないようにする
      const customRecruitmentRoom: Array<ExtInsuredServiceCost> = [];

      /**
       * 登録データに存在して、施設情報の待機者管理の部屋設定(施設固有)に存在しないものを除外する
       */
      const customRoomsToUse = facility.customRecruitmentRoom ? facility.customRecruitmentRoom.filter((room) => room.use) : [];
      // facilities.customRecruitmentRoomをIDで検索しやすいようにSetに変換
      const facilityRoomIdsToUse = new Set(customRoomsToUse.map((room) => room.id));
      // 登録されたデータに存在してfacilities.customRecruitmentRoomに存在しない要素を削除
      // filterを使って、RoomIdsに含まれない要素を除外
      for (const room of usageFees.insuredServiceCosts.customRecruitmentRoom.filter((room) => facilityRoomIdsToUse.has(room.id))) {
        customRecruitmentRoom.push(JSON.parse(JSON.stringify(room)));
      }

      /**
       * 施設情報の待機者管理の部屋設定(施設固有)に存在して、登録データに存在しないものを除外する
       */
      const usageFeesRoomIds = new Set(usageFees.insuredServiceCosts.customRecruitmentRoom.map((room) => room.id));
      const roomsToAdd = facility.customRecruitmentRoom ? facility.customRecruitmentRoom.filter((room) => !usageFeesRoomIds.has(room.id)) : [];

      // 抽出した要素を登録データに初期値で追加
      for (const room of roomsToAdd) {
        if (room.use) {
          customRecruitmentRoom.push({
            supportLevel_1: null,
            supportLevel_2: null,
            careLevel_1: null,
            careLevel_2: null,
            careLevel_3: null,
            careLevel_4: null,
            careLevel_5: null,
            id: room.id,
            roomName: room.name
          });
        }
      }

      const _usageFees: UsageFeesGroupHome = {
        ...usageFees,
        insuredServiceCosts: {
          ...usageFees.insuredServiceCosts,
          customRecruitmentRoom: customRecruitmentRoom // カスタム部屋だけ入れ替える
        }
      };

      return _usageFees;
    }

    return usageFees;
  }

  private restoreUsageFeesOnlyPaymentRate(usageFees: UsageFeesOnlyPaymentRate): UsageFeesOnlyPaymentRate {
    // customRecruitmentRoomの登録データがない場合は初期化する
    if (!usageFees.customRecruitmentRoom) {
      const customRecruitmentRoom: Array<ExtNursingCare> = [];
      for (const room of userStore.facility.customRecruitmentRoom) {
        if (room.use) {
          customRecruitmentRoom.push({
            needNursingCare: {
              none: null,
              percent_10: null,
              percent_20: null,
              percent_30: null
            },
            noNeedNursingCare: {
              none: null,
              percent_10: null,
              percent_20: null,
              percent_30: null
            },
            id: room.id,
            roomName: room.name
          });
        }
      }
      usageFees.customRecruitmentRoom = customRecruitmentRoom;
    }
    // 登録データが存在する場合は画面表示用の復元を行う
    else {
      // カスタム部屋の情報が既に登録されているとVueに値がキャッシュされてしまい、除外したカスタム部屋が表示されてしまう
      // 既存の情報を増減させるのではなく、新しいプロパティにディープコピーしたデータを追加することでキャッシュさせないようにする
      const customRecruitmentRoom: Array<ExtNursingCare> = [];

      /**
       * 登録データに存在して、施設情報の待機者管理の部屋設定(施設固有)に存在しないものを除外する
       */
      const customRoomsToUse = userStore.facility.customRecruitmentRoom ? userStore.facility.customRecruitmentRoom.filter((room) => room.use) : [];
      // facilities.customRecruitmentRoomをIDで検索しやすいようにSetに変換
      const facilityRoomIdsToUse = new Set(customRoomsToUse.map((room) => room.id));
      // 登録されたデータに存在してfacilities.customRecruitmentRoomに存在しない要素を削除
      // filterを使って、bRoomIdsに含まれない要素を除外
      for (const room of usageFees.customRecruitmentRoom.filter((room) => facilityRoomIdsToUse.has(room.id))) {
        customRecruitmentRoom.push(JSON.parse(JSON.stringify(room)));
      }

      /**
       * 施設情報の待機者管理の部屋設定(施設固有)に存在して、登録データに存在しないものを除外する
       */
      const usageFeesRoomIds = new Set(usageFees.customRecruitmentRoom.map((room) => room.id));
      const roomsToAdd = userStore.facility.customRecruitmentRoom ? userStore.facility.customRecruitmentRoom.filter((room) => !usageFeesRoomIds.has(room.id)) : [];
      // 抽出した要素を登録データに初期値で追加
      for (const room of roomsToAdd) {
        if (room.use) {
          customRecruitmentRoom.push({
            needNursingCare: {
              none: null,
              percent_10: null,
              percent_20: null,
              percent_30: null
            },
            noNeedNursingCare: {
              none: null,
              percent_10: null,
              percent_20: null,
              percent_30: null
            },
            id: room.id,
            roomName: room.name
          });
        }
      }

      const _usageFees: UsageFeesOnlyPaymentRate = {
        multiBed: usageFees.multiBed,
        conventinalSingle: usageFees.conventinalSingle,
        unitTypeSingle: usageFees.unitTypeSingle,
        double: usageFees.double,
        single: usageFees.single,
        customRecruitmentRoom: customRecruitmentRoom
      };

      return _usageFees;
    }

    return usageFees;
  }

  /**
   * ### 料金シミュレーション(特養タイプ)の初期情報を作成する
   */
  public createInitializedFeesTokuyo(): UsageFeesTokuyo {
    const rate: UsageFeesTokuyo = {
      livingCosts: {
        multiBed: {
          paymentCeiling_1: null,
          paymentCeiling_2: null,
          paymentCeiling_3_1: null,
          paymentCeiling_3_2: null,
          paymentCeiling_4: null
        },
        conventinalSingle: {
          paymentCeiling_1: null,
          paymentCeiling_2: null,
          paymentCeiling_3_1: null,
          paymentCeiling_3_2: null,
          paymentCeiling_4: null
        },
        unitTypeSingle: {
          paymentCeiling_1: null,
          paymentCeiling_2: null,
          paymentCeiling_3_1: null,
          paymentCeiling_3_2: null,
          paymentCeiling_4: null
        },
        double: {
          paymentCeiling_1: null,
          paymentCeiling_2: null,
          paymentCeiling_3_1: null,
          paymentCeiling_3_2: null,
          paymentCeiling_4: null
        },
        single: {
          paymentCeiling_1: null,
          paymentCeiling_2: null,
          paymentCeiling_3_1: null,
          paymentCeiling_3_2: null,
          paymentCeiling_4: null
        },
        customRecruitmentRoom: []
      },
      foodCosts: {
        paymentCeiling_1: null,
        paymentCeiling_2: null,
        paymentCeiling_3_1: null,
        paymentCeiling_3_2: null,
        paymentCeiling_4: null
      },
      careInsuranceServiceCosts: {
        multiBed: {
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null
        },
        conventinalSingle: {
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null
        },
        unitTypeSingle: {
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null
        },
        double: {
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null
        },
        single: {
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null
        },
        customRecruitmentRoom: []
      },
      careInsuranceAddition: null,
      actualCost: null
    };

    const customRecruitmentRoomForLivingCosts: Array<ExtPaymentCeiling> = [];
    const customRecruitmentRoomForServiceCosts: Array<ExtCareLevel> = [];
    for (const room of userStore.facility.customRecruitmentRoom) {
      if (room.use) {
        customRecruitmentRoomForLivingCosts.push({
          paymentCeiling_1: null,
          paymentCeiling_2: null,
          paymentCeiling_3_1: null,
          paymentCeiling_3_2: null,
          paymentCeiling_4: null,
          id: room.id,
          roomName: room.name
        });
        customRecruitmentRoomForServiceCosts.push({
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null,
          id: room.id,
          roomName: room.name
        });
      }
    }
    rate.livingCosts.customRecruitmentRoom = customRecruitmentRoomForLivingCosts;
    rate.careInsuranceServiceCosts.customRecruitmentRoom = customRecruitmentRoomForServiceCosts;

    return rate;
  }

  private createInitializedFeesGroupHome(): UsageFeesGroupHome {
    const rate: UsageFeesGroupHome = {
      nonCoveredAccommodationCosts: {
        multiBed: {
          rentCost: null,
          mealCost: null,
          managementCost: null,
          utilityCost: null,
          otherCost: null
        },
        conventinalSingle: {
          rentCost: null,
          mealCost: null,
          managementCost: null,
          utilityCost: null,
          otherCost: null
        },
        unitTypeSingle: {
          rentCost: null,
          mealCost: null,
          managementCost: null,
          utilityCost: null,
          otherCost: null
        },
        double: {
          rentCost: null,
          mealCost: null,
          managementCost: null,
          utilityCost: null,
          otherCost: null
        },
        single: {
          rentCost: null,
          mealCost: null,
          managementCost: null,
          utilityCost: null,
          otherCost: null
        },
        customRecruitmentRoom: []
      },
      insuredServiceCosts: {
        multiBed: {
          supportLevel_1: null,
          supportLevel_2: null,
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null
        },
        conventinalSingle: {
          supportLevel_1: null,
          supportLevel_2: null,
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null
        },
        unitTypeSingle: {
          supportLevel_1: null,
          supportLevel_2: null,
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null
        },
        double: {
          supportLevel_1: null,
          supportLevel_2: null,
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null
        },
        single: {
          supportLevel_1: null,
          supportLevel_2: null,
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null
        },
        customRecruitmentRoom: []
      },
      actualCost: null
    };

    const customRecruitmentRoomForAccommodationCosts: Array<ExtAccommodationCost> = [];
    const customRecruitmentRoomForInsuredServiceCosts: Array<ExtInsuredServiceCost> = [];
    for (const room of userStore.facility.customRecruitmentRoom) {
      if (room.use) {
        customRecruitmentRoomForAccommodationCosts.push({
          rentCost: null,
          mealCost: null,
          managementCost: null,
          utilityCost: null,
          otherCost: null,
          id: room.id,
          roomName: room.name
        });
        customRecruitmentRoomForInsuredServiceCosts.push({
          supportLevel_1: null,
          supportLevel_2: null,
          careLevel_1: null,
          careLevel_2: null,
          careLevel_3: null,
          careLevel_4: null,
          careLevel_5: null,
          id: room.id,
          roomName: room.name
        });
      }
    }
    rate.nonCoveredAccommodationCosts.customRecruitmentRoom = customRecruitmentRoomForAccommodationCosts;
    rate.insuredServiceCosts.customRecruitmentRoom = customRecruitmentRoomForInsuredServiceCosts;

    return rate;
  }

  /**
   * ### 料金シミュレーション(自立・負担割合変動タイプ)の初期情報を作成する
   */
  public createInitializedFeesOnlyPaymentRate(): UsageFeesOnlyPaymentRate {
    const rate: UsageFeesOnlyPaymentRate = {
      multiBed: {
        needNursingCare: {
          none: null,
          percent_10: null,
          percent_20: null,
          percent_30: null
        },
        noNeedNursingCare: {
          none: null,
          percent_10: null,
          percent_20: null,
          percent_30: null
        }
      },
      conventinalSingle: {
        needNursingCare: {
          none: null,
          percent_10: null,
          percent_20: null,
          percent_30: null
        },
        noNeedNursingCare: {
          none: null,
          percent_10: null,
          percent_20: null,
          percent_30: null
        }
      },
      unitTypeSingle: {
        needNursingCare: {
          none: null,
          percent_10: null,
          percent_20: null,
          percent_30: null
        },
        noNeedNursingCare: {
          none: null,
          percent_10: null,
          percent_20: null,
          percent_30: null
        }
      },
      double: {
        needNursingCare: {
          none: null,
          percent_10: null,
          percent_20: null,
          percent_30: null
        },
        noNeedNursingCare: {
          none: null,
          percent_10: null,
          percent_20: null,
          percent_30: null
        }
      },
      single: {
        needNursingCare: {
          none: null,
          percent_10: null,
          percent_20: null,
          percent_30: null
        },
        noNeedNursingCare: {
          none: null,
          percent_10: null,
          percent_20: null,
          percent_30: null
        }
      },
      customRecruitmentRoom: []
    };
    const customRecruitmentRoom: Array<ExtNursingCare> = [];
    if (userStore.facility.customRecruitmentRoom) {
      for (const room of userStore.facility.customRecruitmentRoom) {
        if (room.use) {
          customRecruitmentRoom.push({
            needNursingCare: {
              none: null,
              percent_10: null,
              percent_20: null,
              percent_30: null
            },
            noNeedNursingCare: {
              none: null,
              percent_10: null,
              percent_20: null,
              percent_30: null
            },
            id: room.id,
            roomName: room.name
          });
        }
      }
    }
    rate.customRecruitmentRoom = customRecruitmentRoom;
    return rate;
  }

  /**
   * ### 料金シミュレーション(上限・下限タイプ)の初期情報を作成する
   */
  public createInitializedFeesOnlyUpperAndLower(): UsageFeesOnlyUpperAndLower {
    return {
      minCosts: null,
      maxCosts: null
    };
  }

  /**
   * ### 掲載情報を追加する
   */
  public onAddArticle(): void {
    if (this.waiterRecruitment != null) {
      this.waiterRecruitment.articles.push({
        title: "",
        content: ""
      });
    }
    return;
  }

  /**
   * ### 掲載情報を削除する
   */
  public onDeleteArticle(index: number): void {
    if (this.waiterRecruitment != null) {
      this.waiterRecruitment.articles.splice(index, 1);
    }
    return;
  }

  /**
   * ### 画像・動画のバリデーションルールを取得する
   */
  public getMediaValidationRules(media: WaiterRecruitmentMedia): Object {
    if (!media.file) {
      return {
        required: true
      };
    }

    switch (media.file.type) {
      case "image/jpeg":
      case "image/png": {
        return {
          required: true,
          jpeg_png_mp4_mov_file: true,
          file_size: 10
        };
      }
      case "video/mp4":
      case "video/quicktime": {
        return {
          required: true,
          jpeg_png_mp4_mov_file: true,
          file_size: 1000
        };
      }
      default: {
        return {
          required: true,
          jpeg_png_mp4_mov_file: true
        };
      }
    }
  }

  /**
   * ### 画像・動画情報の入力イベント
   *
   * - S3URLを削除する
   * - S3URLを削除することで、S3にファイルアップロードする対象として扱われる
   */
  public inputMedia(media: WaiterRecruitmentMedia): void {
    media.url = "";
    return;
  }

  /**
   * ### 画像・動画情報を追加する
   */
  public onAddMedia(): void {
    if (this.waiterRecruitment != null) {
      this.mediaFiles.push({
        file: null,
        name: "",
        url: "",
        type: "",
        description: ""
      });
    }
    return;
  }

  /**
   * ### プレビューボタンを表示可能か否か
   */
  public disablePreviewButton(file: File): boolean {
    if (!file) {
      return true;
    }

    switch (file.type) {
      case "image/jpeg":
      case "image/png":
      case "video/mp4":
      case "video/quicktime":
      case "application/pdf": {
        return false;
      }
      default: {
        return true;
      }
    }
  }

  /**
   * ### プレビューを表示する
   */
  public onPreview(file: File): void {
    if (!file) {
      return;
    }

    switch (file.type) {
      case "image/jpeg":
      case "image/png": {
        const url: string = window.URL.createObjectURL(file);
        this.imageModalUrl = url;
        this.showImageModal = true;
        break;
      }
      case "video/mp4": {
        const url: string = window.URL.createObjectURL(file);
        this.mp4ModalUrl = url;
        this.showMp4Modal = true;
        break;
      }
      case "video/quicktime": {
        const url: string = window.URL.createObjectURL(file);
        this.movModalUrl = url;
        this.showMovModal = true;
        break;
      }
      case "application/pdf": {
        const url: string = window.URL.createObjectURL(file);
        this.pdfModalUrl = url;
        this.showPdfModal = true;
        break;
      }
      default: {
        return;
      }
    }
  }

  /**
   * ### 画像・動画情報を削除する
   */
  public onDeleteMedia(index: number): void {
    if (this.waiterRecruitment != null) {
      this.mediaFiles.splice(index, 1);
    }
    return;
  }

  /**
   * ### 資料の入力イベント
   *
   * - S3URLを削除する
   * - S3URLを削除することで、S3にファイルアップロードする対象として扱われる
   */
  public inputDocument(document: WaiterRecruitmentDocument): void {
    document.url = "";
    return;
  }

  /**
   * ### 資料を追加する
   */
  public onAddDocument(): void {
    if (this.waiterRecruitment != null) {
      this.documents.push({
        file: null,
        linkText: "",
        name: "",
        url: ""
      });
    }
    return;
  }

  /**
   * ### 資料を削除する
   */
  public onDeleteDocument(index: number): void {
    if (this.waiterRecruitment != null) {
      this.documents.splice(index, 1);
    }
    return;
  }

  /**
   * ### よくある質問を追加する
   */
  public onAddFaq(): void {
    if (this.waiterRecruitment != null) {
      this.waiterRecruitment.faqs.push({
        question: "",
        answer: ""
      });
    }
    return;
  }

  /**
   * ### 掲載情報を削除する
   */
  public onDeleteFaq(index: number): void {
    if (this.waiterRecruitment != null) {
      this.waiterRecruitment.faqs.splice(index, 1);
    }
    return;
  }

  /**
   * ### 入所募集ページLIFFへ遷移する
   */
  public async onMoveToWaiterRecruitment(): Promise<void> {
    const url: string = await this.geWaiterRecruitmentUrl();
    window.open(url, "_blank");
    return;
  }

  public async geWaiterRecruitmentUrl(): Promise<string> {
    const response: string = await this.waiterRecruitmentsService.geWaiterRecruitmentUrl(userStore);
    return response;
  }

  /**
   * ### 入所募集ページ情報登録確認モーダルを表示する
   */
  public async onRegister(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();

    if (validationResult) {
      this.showValidationAlert = false;
      this.registerModalTitle = "入所者募集ページ情報を登録しますか？";
      this.showRegisterModal = true;
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /**
   * ### 入所募集ページを登録する
   */
  public registerWaiterRecruitment(waiterRecruitment: WaiterRecruitmentsGetModel): void {
    const registerWaiterRecruitmentModel: RegisterWaiterRecruitmentModel = this.createRegisterWaiterRecruitmentModel(waiterRecruitment);
    this.$emit("onRegister", registerWaiterRecruitmentModel);
    return;
  }

  /**
   * ### 入所募集ページの登録情報を作成する
   */
  public createRegisterWaiterRecruitmentModel(waiterRecruitment: WaiterRecruitmentsGetModel): RegisterWaiterRecruitmentModel {
    let usageFees: UsageFeesTokuyo | UsageFeesOnlyPaymentRate | UsageFeesOnlyUpperAndLower | UsageFeesGroupHome | null = null;
    switch (waiterRecruitment.usageFeesType) {
      case UsageFeesType.TOKUYOU: {
        usageFees = this.usageFeesTokuyo;
        break;
      }
      case UsageFeesType.GROUP_HOME: {
        usageFees = this.usageFeesGroupHome;
        break;
      }
      case UsageFeesType.ONLY_PAYMENTRATE: {
        usageFees = this.usageFeesOnlyPaymentRate;
        break;
      }
      case UsageFeesType.ONLY_UPPER_AND_LOWER: {
        usageFees = this.usageFeesOnlyUpperAndLower;
        break;
      }
      default: {
        usageFees = null;
      }
    }

    let headerImageFiles: Array<WaiterRecruitmentBasicInformatnHeaderImage> = [];
    if (this.headerImage1) {
      headerImageFiles.push({
        name: this.headerImage1.name,
        type: this.headerImage1.type,
        url: this.headerImageS3Url1,
        file: this.headerImage1
      });
    }
    if (this.headerImage2) {
      headerImageFiles.push({
        name: this.headerImage2.name,
        type: this.headerImage2.type,
        url: this.headerImageS3Url2,
        file: this.headerImage2
      });
    }
    if (this.headerImage3) {
      headerImageFiles.push({
        name: this.headerImage3.name,
        type: this.headerImage3.type,
        url: this.headerImageS3Url3,
        file: this.headerImage3
      });
    }

    return {
      basicInformation: {
        ...waiterRecruitment.basicInformation,
        headerImageFiles: headerImageFiles
      },
      vacancyInformation: waiterRecruitment.showSettings.vacancyInformation ? waiterRecruitment.vacancyInformation : "",
      visitReception: waiterRecruitment.showSettings.visitReception ? waiterRecruitment.visitReception : { description: "" },
      articles: waiterRecruitment.showSettings.articles ? waiterRecruitment.articles : [],
      media: waiterRecruitment.showSettings.media ? this.mediaFiles : [],
      usageFeesType: waiterRecruitment.showSettings.usageFees ? waiterRecruitment.usageFeesType : UsageFeesType.UNKNOWN,
      usageFees: waiterRecruitment.showSettings.usageFees ? (usageFees as any) : null,
      usageFeesInformation: waiterRecruitment.showSettings.usageFees ? waiterRecruitment.usageFeesInformation : null,
      documents: waiterRecruitment.showSettings.documents ? this.documents : [],
      faqs: waiterRecruitment.showSettings.faqs ? waiterRecruitment.faqs : [],
      contact: waiterRecruitment.showSettings.contact ? waiterRecruitment.contact : { description: "", tel: "" },
      showSettings: waiterRecruitment.showSettings
    };
  }

  /**
   * ### 入所募集ページ情報更新確認モーダルを表示する
   */
  public async onUpdate(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();

    if (validationResult) {
      this.showValidationAlert = false;
      this.updateModalTitle = "入所者募集ページ情報を更新しますか？";
      this.showUpdateModal = true;
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /**
   * ### 入所募集ページを更新する
   */
  public updateWaiterRecruitment(waiterRecruitment: WaiterRecruitmentsGetModel): void {
    const updateWaiterRecruitmentModel: UpdateWaiterRecruitmentModel = {
      ...this.createRegisterWaiterRecruitmentModel(waiterRecruitment),
      updated: waiterRecruitment.updated as number
    };
    this.$emit("onUpdate", updateWaiterRecruitmentModel);
    return;
  }
}

export interface WaiterRecruitmentBasicInformation extends BasicInformation {
  /** ヘッダー画像 */
  headerImageFiles: Array<WaiterRecruitmentBasicInformatnHeaderImage>;
}

export interface WaiterRecruitmentBasicInformatnHeaderImage extends HeaderImage {
  file: File | null;
}

export interface WaiterRecruitmentMedia extends Media {
  file: File | null;
}

export interface WaiterRecruitmentDocument extends Document {
  file: File | null;
}

export interface RegisterWaiterRecruitmentModel {
  /** 基本情報 */
  basicInformation: WaiterRecruitmentBasicInformation;
  /** 空室情報 */
  vacancyInformation: string;
  /** 施設見学 */
  visitReception: VisitReception;
  /** 掲載情報 */
  articles: Array<Article>;
  /** 画像・動画情報 */
  media: Array<WaiterRecruitmentMedia>;
  /** 料金シミュレーションタイプ。コード値 */
  usageFeesType: UsageFeesType;
  /** 料金シミュレーション用の情報。費用タイプに応じて内容は可変 */
  usageFees: UsageFeesTokuyo | UsageFeesOnlyPaymentRate | UsageFeesOnlyUpperAndLower;
  /** 料金シミュレーション説明文 */
  usageFeesInformation: string | null;
  /** 資料 */
  documents: Array<WaiterRecruitmentDocument>;
  /** よくある質問 */
  faqs: Array<Faq>;
  /** お問い合わせ */
  contact: Contact;
  /** 各コンテンツの表示可否 */
  showSettings: ShowSetting;
}

export interface UpdateWaiterRecruitmentModel {
  /** 基本情報 */
  basicInformation: WaiterRecruitmentBasicInformation;
  /** 空室情報 */
  vacancyInformation: string;
  /** 施設見学 */
  visitReception: VisitReception;
  /** 掲載情報 */
  articles: Array<Article>;
  /** 画像・動画情報 */
  media: Array<WaiterRecruitmentMedia>;
  /** 料金シミュレーションタイプ。コード値 */
  usageFeesType: UsageFeesType;
  /** 料金シミュレーション用の情報。費用タイプに応じて内容は可変 */
  usageFees: UsageFeesTokuyo | UsageFeesOnlyPaymentRate | UsageFeesOnlyUpperAndLower;
  /** 料金シミュレーション説明文 */
  usageFeesInformation: string | null;
  /** 資料 */
  documents: Array<WaiterRecruitmentDocument>;
  /** よくある質問 */
  faqs: Array<Faq>;
  /** お問い合わせ */
  contact: Contact;
  /** 各コンテンツの表示可否 */
  showSettings: ShowSetting;
  /** 更新日時 */
  updated: number;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.facility-setting-tab {
  position: relative;
  min-height: 240px;

  .tab-content {
    .sns-icon {
      width: 18px;
      height: 18px;
      margin-bottom: 4px;
    }
    .sub-title {
      font-size: 18px;
      font-weight: bold;
    }
    .group {
      width: 740px;
      max-width: 740px;
    }
    .usage-fees-group {
      width: 1020px;
      max-width: 1020px;
    }
    .group-item {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }
    .group-delete-btn,
    .group-add-btn,
    .preview-btn {
      font-size: 16px !important;
      height: 38px !important;
    }

    .validation-label {
      color: $validation-label-font-color;
      font-size: 10px;
      border: 1px solid $validation-label-font-color;
      padding: 1px 4px 0 4px;
      // 「必須」の文字が少し下にズレるでの、marginで調整する
      margin: 2px 6px 4px 0;
    }
    .noinput {
      background-color: $bg-require-input !important;
      &::placeholder {
        color: rgb(117, 117, 117);
      }
    }
  }

  .box-footer {
    padding: 10px 0 0 0 !important;

    .update-btn {
      width: 120px;
    }
  }
}
</style>
